<template>
  <div class="change-camera-playback-button-wrapper">
    <button
      :disabled="disabled"
      @click.stop.prevent="handleClick"
      class="menu-icon-button change-camera-playback-button"
    >
      <span class="menu-icon"></span>
      <span>{{ buttonText }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "ChangeCameraPlaybackButton",
  props: {
    handleClick: {
      type: Function,
      default: () => {},
    },
    buttonText: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_mixin.scss";
@import "@/assets/scss/aisea/_variables.scss";

.change-camera-playback-button-wrapper {
  button {
    all: unset;
    outline: revert;
  }
  display: inline-flex;
  align-items: center;
  gap: 10px;

  width: fit-content;
  height: 21px;

  .menu-icon-button {
    padding: 2px 10px;
    display: flex;
    align-items: center;
    gap: 4px;
    border-radius: 20px;
    background: $aisea-gray-black;
    cursor: pointer;
    .menu-icon {
      width: 11px;
      height: 9px;
      background: url("~@/assets/images/icons/lolcal/recorded_camera_select_button.svg")
        no-repeat;
      background-size: contain;
    }
    &:hover {
      background: $aisea-gray;
    }

    &:active {
      background: $aisea-mouse-gray;
    }

    &:disabled {
      background: $aisea-gray-black;
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
  &.selected {
    .menu-icon-button {
      background: $aisea-blue;
    }
  }
}
</style>
